import {Redux} from "js_utils"


const {
    publish,
    Decorators: {action},
} = Redux

const SCREEN_STORE_PATH = "login"
const LOGIN_FORM_STORE_KEY = "login_form"
const publish_screen = action(publish(SCREEN_STORE_PATH, {
    initial: {
        resetting_password: false,
    },
}))
const publish_login_form = action(publish(LOGIN_FORM_STORE_KEY))


export {
    SCREEN_STORE_PATH, LOGIN_FORM_STORE_KEY,
    publish_screen, publish_login_form,
}
